module.exports = __webpack_public_path__ + "media/images/lb/259-219eb35766e3d6957262215e53bde41d.svg";